<template>
  <div class="workorder-container">
    <div class="content-title">预警工单管理</div>
    <div class="content-item">
      <OrganizationTree @nodeClick="nodeClick"></OrganizationTree>
      <div class="content-right">
        <div class="right-title">工单</div>
        <div class="query">
          <el-form :model="queryForm" ref="queryFormRef" inline  class="search-form">
            <!-- <el-form-item label="预警规则名称：">
              <el-input
                v-model="queryForm.warningRuleName"
                placeholder="请输入预警规则名称"
                clearable
                style="width: 200px"
              />
            </el-form-item> -->
            <el-form-item label="最后修改日期：">
              <el-date-picker
                v-model="queryForm.lastModifyDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="YYYY-MM-DD"
                style="width: 240px"
                clearable
                @change="handleLastModifyDateChange"
              />
            </el-form-item>
            <el-form-item label="检测方式：" prop="EmotionType">
            <el-radio-group v-model="queryForm.EmotionType">
              <el-radio :label="0">{{ recordingTime.seconds30 }}</el-radio>
              <el-radio :label="1">{{ recordingTime.seconds3 }}</el-radio>
            </el-radio-group>
          </el-form-item>
            <el-form-item>
              <!-- <el-button type="primary" icon="Plus" @click="handleAdd">新增</el-button> -->
              <el-button type="primary" icon="Search" @click="handleQuery">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <MyTable :table-options="tableOptions" border max-height="60vh">
          <template #remarks="{ row }">
            {{ Array.isArray(row.remarks) ? row.remarks.join("；") : (row.remarks ?? "-") }}
          </template>
          <template #status="{ row }">
            {{ statusMap[row.status] ?? row.status ?? "-" }}
          </template>
          <template #evaluationDate="{ row }">
            {{ row.evaluationDate ? dayjs(row.evaluationDate).format("YYYY-MM-DD HH:mm:ss") : "-" }}
          </template>
          <template #processTime="{ row }">
            {{ row.processTime ? dayjs(row.processTime).format("YYYY-MM-DD HH:mm:ss") : "-" }}
          </template>
          <template #action="{ row }">
            <MyButton link icon="View" @click="handleView(row)">详情</MyButton>
            <!-- <MyButton link icon="Edit" @click="handleProcess(row)">处理</MyButton> -->
          </template>
        </MyTable>
      </div>
    </div>
    <MyPagination :params="paginationParams" :total="total" @get-list="getWorkOrderList" ref="paginationRef" />
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import { useRouter } from "vue-router";
import OrganizationTree from "@/components/Common/OrganizationTree.vue";
import { ElMessage } from "element-plus";
import { dayjs } from "element-plus";
import warningOrderApi from "@/api/warningOrder";
import {recordingTime } from "@/utils/globalVariable.js"
// 工单状态：0=待处理，1=已处理，2=已关闭，3=已转单
const statusMap = { 0: "待处理", 1: "已处理", 2: "已关闭", 3: "已转单" };

const router = useRouter();

const currentUnit = ref({});
const nodeClick = (data) => {
  console.log(data,"++=")
  if(data!=null){
    currentUnit.value = data;
    paginationParams.warningOrderMainId = data.id || "";
    paginationParams.organizationId = data.id || "";
  }
};

// 查询表单
const queryForm = reactive({
  lastModifyDateRange: null,
  StartLastModifyDate: undefined,
  EndLastModifyDate: undefined,
  EmotionType:0
});

// 最后修改日期范围变化
const handleLastModifyDateChange = (val) => {
  if (!val) {
    queryForm.StartLastModifyDate = undefined;
    queryForm.EndLastModifyDate = undefined;
    return;
  }
  queryForm.StartLastModifyDate = val[0];
  queryForm.EndLastModifyDate = val[1];
};

const queryFormRef = ref(null);

// 表格配置（与 /api/pas/warning-order-main 返回字段一致）
const tableOptions = reactive({
  colList: [
    { label: "序号", type: "index", minWidth: 60 },
    { label: "评测者", prop: "testerName", minWidth: 100, showOverflowTooltip: true },
    { label: "评测时间", prop: "evaluationDate", slot_name: "evaluationDate", minWidth: 170 },
    { label: "描述", prop: "description", minWidth: 120, showOverflowTooltip: true },
    { label: "工单状态", prop: "status", slot_name: "status", minWidth: 100 },
    { label: "关闭原因", prop: "closeReason", minWidth: 120, showOverflowTooltip: true },
    { label: "处理人", prop: "processorName", minWidth: 100, showOverflowTooltip: true },
    { label: "处理时间", prop: "processTime", slot_name: "processTime", minWidth: 170 },
    { label: "操作", type: "slot", slot_name: "action", width: 150, fixed: "right" },
  ],
  tableData: [],
});

// 分页参数（接口：warningOrderMainId, Sorting, SkipCount, MaxResultCount；IsNoList 默认 false 不传）
const paginationParams = reactive({
  warningOrderMainId: "",
  Sorting: "",
  StartLastModifyDate: undefined,
  EndLastModifyDate: undefined,
  organizationId:"",
  EmotionType:0
});

const paginationRef = ref(null);
const total = ref(0);

// 获取预警工单列表
const getWorkOrderList = (params = paginationRef.value?.getList_params) => {
  if (!params.warningOrderMainId) {
    tableOptions.tableData = [];
    total.value = 0;
    return;
  }

  warningOrderApi.getWarningOrderList(params).then((res) => {
    total.value = res.data?.totalCount ?? 0;
    tableOptions.tableData = res.data?.items ?? [];
  }).catch((err) => {
    ElMessage.error(err?.message || "获取预警工单列表失败");
    tableOptions.tableData = [];
    total.value = 0;
  });
};

// 查询（同步筛选条件到分页参数后请求列表）
const handleQuery = () => {
  paginationParams.StartLastModifyDate=queryForm.StartLastModifyDate
  paginationParams.EndLastModifyDate=queryForm.EndLastModifyDate
  paginationParams.EmotionType=queryForm.EmotionType
};

// 查看详情（使用主表 id 或 testerEvaluationId）
const handleView = (row) => {
  const id = row.id || row.testerEvaluationId;
  router.push(`/warningWorkOrder/detail/${id}`);
};
</script>

<style lang="scss" scoped>
.workorder-container {
  padding: 20px;
  background: #03386a;
  min-height: calc(100vh - 60px);

  .content-title {
    font-size: 18px;
    font-weight: bold;
    color: #6fcaf7;
    margin-bottom: 20px;
  }

  .content-item {
    display: flex;
    min-height: 60vh;

    .content-right {
      flex: 1;
      overflow: hidden;

      .right-title {
        background: #134e92;
        height: 40px;
        line-height: 40px;
        color: #66baec;
        display: flex;
        justify-content: space-between;
        padding-left: 20px;
      }

      .query {
        background: #03386a;
        padding: 0 20px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #66baec;

        .search-form {
          padding-top: 20px;
          width: 100%;
          display: flex;
          flex-wrap: wrap;

          :deep(.el-form-item__label) {
            color: #66baec;
          }

          :deep(.el-input__wrapper) {
            background-color: #124e91;
            border-color: transparent;
          }

          :deep(.el-select__wrapper) {
            background-color: #124e91;
            border-color: transparent;
          }

          :deep(.el-date-editor) {
            .el-input__wrapper {
              background-color: #124e91;
            }
          }

          :deep(.el-date-editor),
          :deep(.el-input),
          :deep(.el-select) {
            width: 300px;
          }
        }
      }
    }
  }
}
</style>

